import React from 'react';

type HamburgerCloseProps = {
  className?: string;
  color?: string;
};

const HamburgerClose: React.FC<HamburgerCloseProps> = ({
  className = '',
  color = 'currentColor',
}) => {
  return (
    <svg
      width="80"
      height="36"
      viewBox="0 0 80 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}>
      {/* Top-left to bottom-right */}
      <rect
        x="0"
        y="15.5"
        width="80"
        height="6.5"
        rx="2.5"
        fill={color}
        transform="rotate(35 40 18)"
      />
      {/* Bottom-left to top-right */}
      <rect
        x="0"
        y="15.5"
        width="80"
        height="6.5"
        rx="2.5"
        fill={color}
        transform="rotate(-35 40 18)"
      />
    </svg>
  );
};

export default HamburgerClose;
